import styled from "styled-components";

export const Header = styled.h3.attrs({})`
  color: var(--main-purple-light);
  padding-left: 0.5rem;
`;

export const ModalContainer = styled.div.attrs({})`
  width: inherit;
  background: #fff;
  padding: 2rem;
  max-height: -webkit-fill-available;
  overflow-y: scroll;
`;

export const HeaderContainer = styled.div.attrs({})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;
`;

export const TitleContainer = styled.div.attrs({})``;

export const BodyContainer = styled.div.attrs({})``;

export const CloseBtn = styled.button.attrs({
  className: "text-xl font-medium cursor-pointer bg-transparent border-0",
})`
  color: var(--main-purple-light);
`;

export const LayerContainer = styled.div.attrs({})`
  margin-top: 2rem;
  border: 1px solid #745082;
  border-radius: 10px;
  padding: 20px;
  page-break-after: always;
`;

export const FilterBtn = styled.button.attrs({
  type: "button",
})`
  cursor: pointer;
  border: 0;
  background-color: var(--main-purple-light);
  color: rgb(255, 255, 255);
  min-height: 3rem;
  border-radius: 5px;
  z-index: 1;

  @media (max-width: 768px) {
    right: -10px;
    top: 9rem;
  }
`;

export const LayerContent = styled.div.attrs({})`
  margin-top: 3rem;
  min-height: 10rem;
`;

// KPI summary tiles (Section 1 of the Wound Analysis report)
export const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 10px;
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const KpiTile = styled.div`
  background: #f3eff9;
  border-radius: 8px;
  padding: 14px 8px;
  text-align: center;
`;

export const KpiNum = styled.div`
  font-size: 26px;
  font-weight: 600;
  color: #5a4080;
`;

export const KpiLbl = styled.div`
  font-size: 12px;
  color: #9984c0;
  margin-top: 4px;
  line-height: 1.3;
`;

export const IconContainer = styled.div.attrs({})`
  position: absolute;
  cursor: pointer;
  right: 0;
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Child = styled.div<{ flex: string }>`
  flex: ${({ flex }) => flex};
  padding: 10px;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  position: relative;
  @media (min-width: 769px) {
    width: ${({ flex }) => flex};
  }
`;

export const FallContainer = styled.div.attrs({})`
  position: absolute;
  height: 40vh;
  width: 25%;
  right: 0;
  background: #fff;
  padding: 5px;
  opacity: 1;

  @media (max-width: 575.98px) {
    width: 100%;
  }

  @media (min-width: 576px) and (max-width: 767.98px) {
    width: 50%;
  }

  @media (min-width: 768px) and (max-width: 991.98px) {
    width: 50%;
  }

  @media (min-width: 992px) and (max-width: 1380.98px) {
    width: 30%;
  }
`;

